import { VtsLog, type Id, type Nullable } from "@/models"
import { SearchVtsResult, type SearchVtsRequest } from "@/models/VtsLogSearch"
import { SARLogHttpService } from "@/services/httpService"

export class VtsService extends SARLogHttpService {
	constructor() {
		super("/api/vts-logs")
	}

	async create(log: VtsLog): Promise<VtsLog> {
		return await this.returning(VtsLog).post("", log)
	}

	async update(log: VtsLog): Promise<VtsLog> {
		return await this.returning(VtsLog).put("", log)
	}

	async getById(id: Id): Promise<Nullable<VtsLog>> {
		return await this.returning(VtsLog.nullable()).get(`${id}`)
	}

	async search(request: SearchVtsRequest): Promise<SearchVtsResult> {
		return await this.returning(SearchVtsResult).post("search", request)
	}

	async export(request: SearchVtsRequest): Promise<Blob> {
		return await this.returningBlob().post("search/export", request)
	}
}
